<template>
  <van-nav-bar
    :title="$t('routerBase.'+$route.meta.title)"
    fixed
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
</template>

<script>

export default {
  methods: {
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    //   Toast('返回')
    },
    onClickRight() {
    //   $this.Toast('按钮')
    }
  }
}
</script>

<style lang="scss" scoped>
  .van-nav-bar .van-icon {
    color: #F18937;
    font-size: 18px;
  }
  .van-nav-bar__title{
    color: #000000
  }
</style>

